module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson5/modals/lesson_5_12_f.pdf";